export type Language = "NL" | "FR" | "EN" | "NAN";

export enum Locales {
  NL = "nl-BE",
  FR = "fr-BE",
  EN = "en-GB",
  NAN = "nan",
}
